<script setup lang="ts">
import type { InsurancePolicy } from '../internal/types.ts'
import { formatDate } from '@taler/domain'
import { useI18n } from 'vue-i18n'

defineProps<{ policies: readonly InsurancePolicy[] }>()
defineEmits<{ delete: [policyId: string] }>()

const { t, locale } = useI18n()
</script>

<template>
  <p v-if="policies.length === 0" class="text-[color:var(--color-text-muted)]">
    {{ t('garage.policies.empty') }}
  </p>

  <ul v-else class="flex flex-col gap-2">
    <li
      v-for="policy in policies"
      :key="policy.id"
      class="flex items-center justify-between gap-3 rounded-[var(--radius-surface)] border border-[color:var(--color-border)] p-3 bg-[color:var(--color-surface)]"
    >
      <div class="flex flex-col gap-1">
        <span class="text-[length:var(--text-step-3)] font-medium text-[color:var(--color-text)]"
          >{{ policy.insurer }}
          <span v-if="policy.policyNumber" class="text-[color:var(--color-text-muted)]"
            >— {{ policy.policyNumber }}</span
          ></span
        >
        <span class="text-[length:var(--text-step-1)] text-[color:var(--color-text-muted)]">{{
          t(`garage.policyType.${policy.type}`)
        }}</span>
        <span
          v-if="policy.coverageStart && policy.coverageEnd"
          class="text-[length:var(--text-step-1)] text-[color:var(--color-text-muted)]"
        >
          {{ formatDate(policy.coverageStart, locale as 'en' | 'hu') }} –
          {{ formatDate(policy.coverageEnd, locale as 'en' | 'hu') }}
        </span>
      </div>
      <button
        type="button"
        class="min-h-[var(--density-target-min)] rounded-[var(--radius-control)] border border-[color:var(--color-border-control)] px-2 py-1 text-[length:var(--text-step-1)] text-[color:var(--color-danger)]"
        :aria-label="`${t('garage.policies.delete')} ${policy.insurer}`"
        @click="$emit('delete', policy.id)"
      >
        {{ t('garage.policies.delete') }}
      </button>
    </li>
  </ul>
</template>
